<template>
  <bubble-menu
    :editor="editor"
    :tippy-options="{ duration: 100, maxWidth: 'none' }"
    v-if="editor"
    ref="menu"
  >
    <v-card outlined>
      <v-row no-gutters>
        <v-col
          v-for="button in marksButtons"
          :key="button.value"
        >
          <keyboard-tooltip
            :key-name="button.shortcut"
            :label="button.label"
          >
            <v-btn
              :value="button.value"
              @click="button.action"
              small
              depressed
              :color="button.active ? 'primary' : null"
              :text="!button.active"
              style="min-width: 28px"
              class="px-1 ma-1"
            >
              <v-icon small>
                {{ button.icon }}
              </v-icon>
            </v-btn>
          </keyboard-tooltip>
        </v-col>
        <v-divider vertical />
        <editor-menu
          :items="nodesButtons.filter((t) => t.canConvertSelection)"
          :label="$t('textEditor.buttons.turnInto')"
          icon="mdi-cached"
        />

        <template v-if="tablesButtons.length > 0">
          <v-divider vertical />

          <editor-menu
            :items="tablesButtons"
            :label="$t('textEditor.buttons.table.menuLabel')"
            icon="mdi-table"
          />
        </template>
      </v-row>
    </v-card>
  </bubble-menu>
</template>

<script>
import { inject, ref, watch } from "vue"
import { BubbleMenu } from "@tiptap/vue-2"
import EditorMenu from "./editor_menu.vue"
import KeyboardTooltip from "../keyboard_tooltip.vue"
import useTextEditorButtons from "./useTextEditorButtons"
import { useElementVisibility, watchPausable } from "@vueuse/core"

export default {
  name: "TextEditorBubbleMenu",
  components: {
    BubbleMenu,
    EditorMenu,
    KeyboardTooltip,
  },
  props: {
    featureTable: {
      type: Boolean,
      default: true,
    },
    featureMath: {
      type: Boolean,
      default: true,
    },
    featureCode: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const editor = inject("editor")
    const menu = ref(null)
    const isVisible = useElementVisibility(menu)

    const { marksButtons, nodesButtons, tablesButtons } = useTextEditorButtons(editor, {
      featureTable: props.featureTable,
      featureMath: props.featureMath,
      featureCode: props.featureCode,
    })

    const debouncedMarksButtons = ref([])
    const debouncedNodesButtons = ref([])
    const debouncedTablesButtons = ref([])

    const { pause, resume } = watchPausable(
      [marksButtons, nodesButtons, tablesButtons],
      ([marks, nodes, tables]) => {
        debouncedMarksButtons.value = marks
        debouncedNodesButtons.value = nodes
        debouncedTablesButtons.value = tables
      },
    )

    // Pause the watcher when the menu is not visible to avoid unnecessary re-renders
    watch(isVisible, (v) => v ? resume() : pause())

    return {
      marksButtons: debouncedMarksButtons,
      nodesButtons: debouncedNodesButtons,
      tablesButtons: debouncedTablesButtons,
      editor,
      isVisible,
      menu,
    }
  },
}
</script>
